import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { useState, useEffect } from "react";
import { TableOrderSummary } from "./TableOrderSummary";
import { calculateOrderTotal } from "../Utils/utils";
import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { PlaceOrderTypeDialog } from "../dialogs/PlaceOrderTypeDialog";
import { CheckOutInfoDialog } from "../dialogs/CheckOutInfoDialog";
import { UpSellItemCategoryDialog } from "../dialogs/UpSellItemCategoryDialog";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export const RightBar = (props) => {
  const {
    menuDirection,
    onRemove,
    orders,
    taxes,
    onEdit,
    orderType,
    deliveryCharge,
    editOrder,
    enablePromoCode,
    onPromoCode,
    promoCode,
    onOrderSelection,
    companyName,
    pickUpTime,
    deliveryTime,
    choiceItemsCategories,
    onProductClick,
    serviceCharges,
    settings,
    companyData,
  } = props;
  const [order, setOrder] = useState({});
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [notes, setSetNotes] = useState("");
  const [upSoldItem, setUpSoldItem] = useState(false);
  const {
    AllowDiscountOnDelivery,
    AllowDiscountOnPickup,
    OnlineSpecialDiscount,
    OnlineCombineLineQty,
    MinimumDeliveryOrder,
    MinimumDeliveryOrderAmt,
  } = settings;

  const handleNotes = (e) => {
    const id = e.target.id;
    const value = e.target.value;

    setSetNotes(value);
  };

  const handlePromoCode = async () => {
    try {
      const element = document.getElementById("promoCode");
      onPromoCode(element.value);
    } catch (error) {
      alert("error");
    }
  };

  const handleTip = (value, type) => {
    let orderCopy = { ...order };
    if (orderCopy.tip) {
      orderCopy.orderTotal = orderCopy.orderTotal - orderCopy.tip;
    }
    if (type === "percentage") {
     
      orderCopy.tip =
        Math.round(
          (orderCopy.subTotal * (value / 100) + Number.EPSILON) * 100
        ) / 100;
    } else {
      orderCopy.tip =
        Math.round(
          (parseFloat(value.target.value == "" ? 0 : value.target.value) +
            Number.EPSILON) *
            100
        ) / 100;
    }
    orderCopy.orderTotal = orderCopy.orderTotal + orderCopy.tip;
    setOrder({ ...orderCopy });
  };

  const handleDeliveryCharge = (value, type) => {
    let orderCopy = { ...order };
    orderCopy.deliveryCharge = value;

    orderCopy.orderTotal = orderCopy.orderTotal + orderCopy.deliveryCharge;
    setOrder({ ...orderCopy });
  };

  const handleCustomerData = (customerData) => {
    let orderCopy = { ...order };

    customerData.onDate = `${
      customerData.date.getMonth() + 1
    }/${customerData.date.getDate()}/${customerData.date.getFullYear()}`;
    customerData.onTime = `${customerData.time
      .getHours()
      .toString()
      .padStart(2, "0")}:${customerData.time
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${customerData.time
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
    Object.assign(orderCopy, customerData);
    setOrder(orderCopy);
  };

  useEffect(() => {
    const order = calculateOrderTotal({
      editOrder,
      orderType,
      orders,
      deliveryCharge,
      taxes,
      promoCode,
      serviceCharges,
      AllowDiscountOnDelivery,
      AllowDiscountOnPickup,
      OnlineSpecialDiscount,
      OnlineCombineLineQty,
    });
    setOrder({ ...order });
  }, [orders, promoCode]);

  return (
    <Paper
      elevation={12}
      p={2}
      sx={{
        display: { xs: "none", lg: "block" },
        // boxShadow: "0px 3px 0px 1px #972020",
        width: "25%",
        position: "fixed",
        right: 0,
        height: "100vh",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "55%",
          margin: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: "5px 10px",
          }}
        >
          <TableOrderSummary
            order={order}
            taxes={taxes}
            onEdit={onEdit}
            onRemove={onRemove}
          />
          <TextField
            id="notes"
            label="Note"
            multiline
            rows={4}
            fullWidth
            placeholder="..."
            value={notes}
            onChange={handleNotes}
            component={Paper}
            elevation={3}
            sx={{
              marginTop: "10px",
            }}
          />
          {orderType === "Delivery" &&
          MinimumDeliveryOrder == 1 &&
          order.orderTotal < MinimumDeliveryOrderAmt ? (
            <Typography>{`You must order items worth $${MinimumDeliveryOrderAmt} for delivery`}</Typography>
          ) : null}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {enablePromoCode == "1" ? (
              <FormControl
                fullWidth
                sx={{
                  marginTop: "10px",
                  marginRight: "5px",
                }}
                disable={order?.promoCode}
              >
                <InputLabel htmlFor="promoCode">Promo Code</InputLabel>
                <OutlinedInput
                  id="promoCode"
                  endAdornment={
                    <InputAdornment position="end">
                      <Button variant="outlined" onClick={handlePromoCode}>
                        Apply
                      </Button>
                    </InputAdornment>
                  }
                  label="Apply Promo Code"
                />
              </FormControl>
            ) : null}

            <Button
              autoFocus
              sx={{ marginTop: "10px", height: "55px", marginRight: "0px" }}
              variant="contained"
              onClick={() => setPaymentOpen(true)}
              disabled={
                !(orders.length > 0) ||
                (orderType === "Delivery" &&
                  MinimumDeliveryOrder == 1 &&
                  order.orderTotal < MinimumDeliveryOrderAmt)
              }
            >
              Place order
            </Button>
          </Box>
        </Box>
      </Box>
      {paymentOpen && upSoldItem ? (
        <CheckOutInfoDialog
          open={paymentOpen}
          onClose={() => setPaymentOpen(false)}
          onOrderSelection={onOrderSelection}
          companyName={companyName}
          deliveryCharge={deliveryCharge}
          pickUpTime={pickUpTime}
          deliveryTime={deliveryTime}
          order={order}
          onTipChange={handleTip}
          handleDeliveryCharge={handleDeliveryCharge}
          saveCustomerData={handleCustomerData}
          settings={settings}
          orderType={orderType}
          companyData={companyData}
        />
      ) : null}
      {paymentOpen && !upSoldItem ? (
        <UpSellItemCategoryDialog
          open={paymentOpen}
          onClose={() => {
            setPaymentOpen(false);
            setUpSoldItem(true);
          }}
          onNo={() => setUpSoldItem(true)}
          choiceItemsCategories={choiceItemsCategories}
          onProductClick={onProductClick}
          onUpsellItem={() => setUpSoldItem(true)}
        />
      ) : null}
    </Paper>
  );
};
